import { render, staticRenderFns } from "./TopicInfo.vue?vue&type=template&id=3aec43b2&scoped=true&"
import script from "./TopicInfo.vue?vue&type=script&lang=js&"
export * from "./TopicInfo.vue?vue&type=script&lang=js&"
import style0 from "./TopicInfo.vue?vue&type=style&index=0&id=3aec43b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec43b2",
  null
  
)

export default component.exports